import { render } from "./NcrmActivitiesFilters.vue?vue&type=template&id=27c3bc63&scoped=true"
import script from "./NcrmActivitiesFilters.vue?vue&type=script&lang=js"
export * from "./NcrmActivitiesFilters.vue?vue&type=script&lang=js"

import "./NcrmActivitiesFilters.vue?vue&type=style&index=0&id=27c3bc63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c3bc63"]])

export default __exports__